export default __webpack_public_path__ + "static/media/likewise-logo.25dc387a.svg";